"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnName = exports.ColumnNumber = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const useStyles = makeStyles_1.default((theme) => ({
    columnNumber: {
        width: '2rem',
        height: '2rem',
        backgroundColor: theme.palette.black.main,
        color: theme.palette.common.white,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    columnName: {
        width: '100%',
        background: theme.palette.black['600'],
        border: `0.0625rem solid ${theme.palette.black.light}`,
        borderRadius: '0.25rem',
        padding: theme.spacing(1),
    },
    importedColumnName: {
        backgroundColor: theme.palette.common.white,
        '& .MuiOutlinedInput-input': {
            padding: '0.6875rem',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.black.light,
        },
        '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.black.light,
        },
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.black.light,
            borderWidth: '0.0625rem',
        },
    },
}));
exports.ColumnNumber = (props) => {
    const { row } = props;
    const classes = useStyles();
    return react_1.default.createElement(material_1.Box, { className: classes.columnNumber }, row.id);
};
const useColumnNameStyles = (variant) => makeStyles_1.default((theme) => ({
    columnName: {
        width: '100%',
        background: variant === 'default' ? theme.palette.black['600'] : 'none',
        border: `0.0625rem solid ${theme.palette.black.light}`,
        borderRadius: '0.25rem',
        padding: theme.spacing(1),
        overflow: 'hidden',
    },
}));
exports.ColumnName = (props) => {
    const { variant, value } = props;
    const classes = useColumnNameStyles(variant)();
    return (react_1.default.createElement(material_1.Box, { className: classes.columnName },
        react_1.default.createElement(material_1.Typography, { variant: "body1" }, value)));
};
//# sourceMappingURL=data:application/json;base64,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